// extracted by mini-css-extract-plugin
export default {"controlledIconBlock":"radioTabGroup_controlledIconBlock__HxSzW"};